import axios from "axios";

function statusClass(n) {
  return Math.floor( n / 100 );
}

//============================================================================================
export function reqConfig() {
  return {
    headers: {
      'X-CSRF-Token': document.querySelector("meta[name='csrf-token']").getAttribute("content"),
      'Content-Type': 'application/json',
    }
  }
}

//============================================================================================
export async function ping( str ) {
  const config = {
    // headers: {
    //   Authorization: `Bearer ${token}`
    // }
  };

  const response = await axios.get( '/ping', config );
  if (!response.data.msg) {
    console.log( '[Connections ping] no data ' );
  } else {
    console.log( response.data.msg );
  }
  return response.data;
}

//============================================================================================
/* Usage: 
  api_request( '/api/some-endpoint', 'post', { key: 'value' } )
  .then( (data) => {
    // Handle successful response data;
  })
  .catch( err => showErrorModal(err.message) );
*/

export default async function api_request( url, method, data, cfg = {}, headers = {} ) {
  const axcfg = {
    ...cfg,
    headers: {
      'X-CSRF-Token': document.querySelector("meta[name='csrf-token']").getAttribute("content"),
      'Content-Type': 'application/json',
      ...headers
    },
    method: method,
    url,
    data
  }
  return axios( axcfg )
  .catch( (error) => {
    let message = '';
    if (error.response) {
      // Request made and server responded
      if (error.response.data && error.response.data.message) {
        console.log( '[API Request] ', error.response.data.message );
        message = `Response Error: ${error.response.data.message}`;
        console.log(error.response.data);
      } else {
        console.log( '[API Request] no message' );
        message ='Unknown response error';
      }
      console.log(error.response.status);
      console.log(error.response.headers);
    } else if (error.request) {
      // The request was made but no response was received
      console.log('[API Request] no response', error.request);
      message = 'No response from server';
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('[API Request] request Error', error.message);
      message = `Request Error: ${error.message}`;
    }  
    const err = new Error( `Connection error: ${message}` );
    console.log(err.name + ': ' + err.message);
    throw err;
  }) // catch error
  .then( (res) => {
    if ( statusClass( res.status ) === 2 ) {
        console.log( '[API Request] ', res.data )
        return res.data;
    } else {
      let errorMessage = `[API Request] Request failed with status ${res.status}!`;
      if (res.data && res.data.message) {
        errorMessage = `[API Request] Request failed with status ${res.status}: ${res.data.message}`;
      }
      throw new Error(errorMessage);
    }
  })  
  .finally(() => {
    console.log('[API Request] Completed');
  });
}
